<template>
  <a-card :bordered="false">
    <div>
      <a-button type="primary" @click="openModel">绑定商品</a-button>
    </div>
    <custom-page-table
      style="margin-top: 16px;"
      ref="table"
      :columns="columns"
      :enableSearch="false"
      :queryParams="searchQueryParams"
      :requestPromise="loadPromise"
    >
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm title="是否要删除绑定" @confirm="deleteProBind(rowItem.record.bindId)">
          <a>删除绑定</a>
        </a-popconfirm>
      </span>
    </custom-page-table>
    <a-modal title="商品绑定" :width="666" :footer="null" :visible="visible" @cancel="handleCancel">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" :label-col="currentDialogLayout.labelCol"
                    :wrapper-col="currentDialogLayout.wrapperCol">
        <a-form-model-item label="所属供应商" prop="ydBusAccountId">
          <a-select v-model="ruleForm.ydBusAccountId" placeholder="请选择供应商" @change="handleChange">
            <a-select-option v-for="item in providerList" :key="item.id" :value="item.id">
              {{ item.supplierName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="关联商品" required>
          <a-button type="primary" @click="toSelectedProductEvent">选择商品</a-button>
          <span style="margin-left: 10px;">*仅能关联门票类型且未上架的自有产品</span>
        </a-form-model-item>
        <a-form-model-item v-if="ruleForm.proId" label="商品名称" prop="proId">
          <span style="margin-left: 10px;">{{ ruleForm.proId }} {{ ruleForm.proName }}</span>
        </a-form-model-item>
        <a-form-model-item label="选择票型" prop="optionId">
          <a-select v-model="ruleForm.optionId" placeholder="请选择票型" allowClear>
            <a-select-option v-for="item in optionList" :key="item.optionId" :value="item.optionId">
              {{ item.optionName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="供应商车票" prop="busTicketId">
          <a-select v-model="ruleForm.busTicketId" placeholder="请选择供应商车票" allowClear
                    @change="handleTicketChange">
            <a-select-option v-for="item in supplierTicketList" :key="item.busTicketId" :value="item.busTicketId">
              {{ item.busTicketName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <div style="text-align: center;">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading" style="width: 180px;">保存设置
          </a-button>
        </div>
      </a-form-model>
    </a-modal>
    <selected-product-dialog
      :show="showSelectedDialog"
      ref="pageList"
      :itemNames="['search_proId','search_proName']"
      :query-params="selectedQueryParams"
      :requestPromise="loadProductPromise"
      row-key="proId"
      @close="showSelectedDialog=false"
      :columns="getGoodsColumns()"
    >
      <a-form-item label="商品ID" slot="search_proId" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proId" style="width: 170px" placeholder="请输入商品ID"></a-input>
      </a-form-item>
      <a-form-item label="商品名称" slot="search_proName" v-bind="currentDialogLayout">
        <a-input v-model="selectedQueryParams.proName" style="width: 170px" placeholder="请输入商品名称"></a-input>
      </a-form-item>
      <template slot="proTypeSlot" slot-scope="rowItem">{{ rowItem.text|productTypeName }}</template>
      <template slot="action" slot-scope="rowItem">
        <a-button type="primary" @click="onSelectedResult(rowItem.record)">选择</a-button>
      </template>
    </selected-product-dialog>
  </a-card>
</template>

<script>
import { mapState } from 'vuex'
import SelectedProductDialog from '@/customComponents/SelectedProductDialog/SelectedProductDialog'

export default {
  name: 'BusConnection',
  components: { SelectedProductDialog },
  data() {
    return {
      currentDialogLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      searchQueryParams: {},
      selectedQueryParams: {
        proName: '',
        proId: '',
        proSource: 0,
        proStatus: 0,
        proType: 1
      },
      loadProductPromise: params => this.getProductListPromise(params),
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '商品ID',
          dataIndex: 'proId'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '25%'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '类型',
          dataIndex: 'proTypeName',
          width: '80px'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          width: '120px'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName',
          width: '140px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      visible: false,
      showSelectedDialog: false,
      ruleForm: {
        busTicketId: undefined,// 车票id ,
        busTicketName: '',// 车票名称 ,
        optionId: undefined,// 套餐id ,
        proId: '',// 商品id ,
        ydBusAccountId: undefined,// 优点巴士账号id ,
        ydBusAccountName: ''// 优点巴士账号名称
      },
      rules: {
        ydBusAccountId: [{ required: true, message: '请选择供应商名称', trigger: 'change' }],
        proId: [{ required: true, message: '请关联商品品', trigger: 'change' }],
        optionId: [{ required: true, message: '请选择票型', trigger: 'change' }],
        busTicketId: [{ required: true, message: '请选择供应商车票', trigger: 'change' }]
      },
      providerList: [],
      selectedProduct: {},
      supplierTicketList: [],
      optionList: [],
      submitLoading: false,
      submitFormData: ''
    }
  },
  computed: {
    ...mapState({
      vesion: state => state.config.serverDataInfo.vesion
    })
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'BusConnection', title: '商品绑定' },
      { name: 'BusOrderConnection', title: '订单直连' },
      { name: 'BusNewAccount', title: '关联账号' }
    ])
  },
  methods: {
    //选择商品
    toSelectedProductEvent() {
      this.showSelectedDialog = true
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getProService().post('v2/ydbus/product/findBoundYdBusTicketList', params)
    },
    getProductListPromise(params) {
      return this.getHttpServices().getProService().post('api/v2/productManage/findProductList', params)
    },
    getGoodsColumns() {
      return [
        {
          title: '商品ID',
          dataIndex: 'proId',
          width: '100px'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '商品分类',
          dataIndex: 'proType',
          width: '100px',
          scopedSlots: { customRender: 'proTypeSlot' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    //商品数据点击
    onSelectedResult(item) {
      this.selectedProduct = item
      this.getTicketOptionList(item.proId)
      this.ruleForm.proName = item.proName
      this.ruleForm.proId = item.proId
      this.ruleForm.optionId = undefined
      this.showSelectedDialog = false
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      delete this.submitFormData.proName
      this.getHttpServices().getProService().post('v2/ydbus/product/boundYdBusTicket', this.submitFormData).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success('保存成功')
        this.visible = false
        this.resetFrom()
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    //解除绑定
    deleteProBind(bindId) {
      let params = {
        bindId: bindId
      }
      this.getHttpServices().getProService().post('v2/ydbus/product/removeBoundYdBusTicket', params).then(res => {
        this.getLogUtils().logWithTag('deleteProBind', res)
        this.$message.success('删除绑定成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //获取供应商列表
    getProviderList() {
      let params = {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId,
        state: 1,
        limitDto: { pageNum: 1, pageSize: 1000 }
      }
      this.getHttpServices().getServerApiService().post('ydbus/findYdBusAccountList', params).then(res => {
        this.getLogUtils().logWithTag('getProviderList', res)
        if (res.data && res.data.length > 0) {
          this.providerList = res.data
        } else {
          this.providerList = []
        }
      }).catch(reason => {
        this.providerList = []
        this.showNetWorkErrorMessage(reason)
      })
    },
    //获取供应商车票列表
    getYdBusTicketList(id) {
      this.getHttpServices().getServerApiService().get('ydbus/getYdBusTicketList?id=' + id).then(res => {
        this.getLogUtils().logWithTag('getYdBusTicketList', res)
        if (res && res.length > 0) {
          this.supplierTicketList = res
        } else {
          this.supplierTicketList = []
        }
      }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
        this.supplierTicketList = []
      })
    },
    //获取票型列表
    getTicketOptionList(proId) {
      this.getHttpServices().getProService().get('v2/ydbus/product/getTicketOptionList?proId=' + proId).then(res => {
        this.getLogUtils().logWithTag('getTicketOptionList', res)
        if (res && res.length > 0) {
          this.optionList = res
        } else {
          this.optionList = []
        }
      }).catch(reason => {
        this.optionList = []
        this.showNetWorkErrorMessage(reason)
      })
    },
    handleChange(value) {
      if (value) {
        this.ruleForm.ydBusAccountName = this.providerList.filter(item => item.id == value)[0].supplierName
      } else {
        this.ruleForm.ydBusAccountName = ''
      }
      this.ruleForm.busTicketId = undefined
      this.ruleForm.busTicketName = ''
      this.getLogUtils().logWithTag('ydBusAccountName', this.ruleForm.ydBusAccountName)
      this.getYdBusTicketList(value)
    },
    handleTicketChange(value) {
      this.getLogUtils().logWithTag('handleTicketChange', value)
      if (value) {
        this.ruleForm.busTicketName = this.supplierTicketList.filter(item => item.busTicketId == value)[0].busTicketName
      } else {
        this.ruleForm.busTicketName = ''
      }
      this.getLogUtils().logWithTag('ydBusAccountName', this.ruleForm.busTicketName)
    },
    openModel() {
      this.visible = true
      this.getProviderList()
    },
    handleCancel() {
      this.visible = false
    },
    resetFrom() {
      this.ruleForm = {
        busTicketId: undefined,// 车票id ,
        busTicketName: '',// 车票名称 ,
        optionId: undefined,// 套餐id ,
        proId: '',// 商品id ,
        ydBusAccountId: undefined,// 优点巴士账号id ,
        ydBusAccountName: ''// 优点巴士账号名称
      }
    }
  }
}
</script>
<style scoped></style>
